import { render, staticRenderFns } from "./KioskStyle.vue?vue&type=template&id=4fe7911c&scoped=true"
import script from "./KioskStyle.vue?vue&type=script&lang=js"
export * from "./KioskStyle.vue?vue&type=script&lang=js"
import style0 from "./KioskStyle.vue?vue&type=style&index=0&id=4fe7911c&prod&lang=scss&scoped=true"
import style1 from "./KioskStyle.vue?vue&type=style&index=1&id=4fe7911c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe7911c",
  null
  
)

export default component.exports